import React, { Component } from 'react';
import flag from '../../assets/img/brazil-flag-icon-32.png';

export default class Header extends Component {
  render() {
    return (
      <nav className="navbar navbar-light navbar-expand bg-light navigation-clean">
        <div className="container">
          <a className="navbar-brand m-auto" href="/">
            <h2 className="d-flex align-items-baseline" style={{ fontWeight: 300 }}>
              <img src={flag} alt="Bandeira do Brasil"/>
          &nbsp;Brasil Open Data
        </h2>
          </a>
        </div>
      </nav>
    )
  }
}
